import ReactDOM from 'react-dom/client'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { AuthProvider } from './contexts/AuthContext'
import './index.scss'
import { CartProvider } from './contexts/CartContext'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false
    }
  }
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <>
    <QueryClientProvider client={queryClient}>
      <CartProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </CartProvider>
    </QueryClientProvider>
  </>
)

reportWebVitals()
